export * from './ReactMap';
export { default as ReactMap, ReactMapRef } from './ReactMap';
export { default as ReactEsriMap, ReactEsriMapRef } from './ReactEsriMap';
export { default as ReactMapEsri } from './ReactMapEsri';

// Wrapper components — render the correct implementation based on
// the `info360-platform-esri-map` feature flag.
export { default as AssetGrid } from './map-components/AssetGrid';
export type { AssetGridProps } from '../map/esri/features/AssetGrid/AssetGrid';
export { default as PropertyPane } from './map-components/PropertyPane';
export type { PropertyPaneProps as EsriMapPropertyPaneProps } from './map-components/PropertyPane';
export { default as FilterCard } from './map-components/FilterCard';
export type { FilterCardProps } from './map-components/FilterCard';
export { default as FilterProvider } from './map-components/FilterProvider';
export type { FilterProviderProps } from './map-components/FilterProvider';

// TabTypes: lib-inno-map's enum (values are identical to map-components).
export { TabTypes } from '../map/esri/features/PropertyPane/PropertyPane';

// Re-exports from @innovyze/map-components (types/utilities with no Esri equivalent).
// These resolve once `npm install` has been run with the correct registry auth.
// Note: `Asset` is intentionally omitted here — it conflicts with the geocoder
// `Asset` that is re-exported through `./map/types` → `./geocoder/types`.
// Consuming apps that need `Asset` should import it directly from
// `@innovyze/map-components` until that ambiguity is cleaned up.
export type { InspectionScoredAttributes } from '@innovyze/map-components';
export { GridMenuItems, getMapLayerId } from '@innovyze/map-components';

// Esri-specific exports (retained for backwards compat and Esri-only consumers).
export type { Props as EsriPropertyPaneProps } from '../map/esri/features/PropertyPane/PropertyPane';
export type { SelectedAsset as EsriSelectedAsset } from '../map/esri/features/PropertyPane/PropertyPaneProps';
export { usePropertyPane } from '../map/esri/features/usePropertyPane';
// allGridMenuItems and useFilters were previously exported via
// `export * from '../map/esri/features/AssetGrid'` — kept for backward compat.
export { allGridMenuItems } from '../map/esri/features/AssetGrid/utils/getActions';
export { useFilters } from '../map/esri/features/useFilters';
export * from './Geocoder';
export { default as Geocoder } from './Geocoder';
export { default as EsriGeocoder } from '../map/esri/features/Search/components/Geocoder/EsriGeocoder';
export type { EsriGeocoderProps } from '../map/esri/features/Search/components/Geocoder/EsriGeocoder';
export { FlyTo as EsriFlyTo } from '../map/esri/features/Search/types';
export * from './types';
export { LayerPanel } from '../map/esri/features/LayerPanel';
export type { LayerPanelProps as EsriLayerPanelProps } from '../map/esri/features/LayerPanel';
